import { Pipe, PipeTransform } from '@angular/core';

import { parameterClass } from '../constants/constants';

@Pipe({ name: 'parameterClass' })
export class ParameterClassPipe implements PipeTransform {
  transform(parameter: string) {
    return parameterClass(parameter);
  }
}
